var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.819 15.5017L27.8803 15.8463L28.819 15.5017ZM28.819 16.6913L29.7578 17.0359L28.819 16.6913ZM3.77805 16.6913L2.83931 17.0359L3.77805 16.6913ZM4.7168 15.8463C6.44909 11.1274 10.9822 7.76318 16.2985 7.76318V5.76318C10.1167 5.76318 4.85133 9.67617 2.83931 15.1571L4.7168 15.8463ZM16.2985 7.76318C21.6149 7.76318 26.148 11.1274 27.8803 15.8463L29.7578 15.1571C27.7457 9.67617 22.4804 5.76318 16.2985 5.76318V7.76318ZM27.8803 16.3467C26.148 21.0656 21.6149 24.4299 16.2985 24.4299V26.4299C22.4804 26.4299 27.7457 22.5169 29.7578 17.0359L27.8803 16.3467ZM16.2985 24.4299C10.9822 24.4299 6.44909 21.0656 4.7168 16.3467L2.83931 17.0359C4.85133 22.5169 10.1167 26.4299 16.2985 26.4299V24.4299ZM27.8803 15.8463C27.9395 16.0077 27.9395 16.1853 27.8803 16.3467L29.7578 17.0359C29.9804 16.4296 29.9804 15.7635 29.7578 15.1571L27.8803 15.8463ZM2.83931 15.1571C2.61672 15.7635 2.61672 16.4296 2.83931 17.0359L4.7168 16.3467C4.65755 16.1853 4.65755 16.0077 4.7168 15.8463L2.83931 15.1571Z",
    fill: "#0384CC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2983,
    cy: 16.0964,
    r: 4,
    fill: "#0384CC",
    stroke: "#0384CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.9d7b3d4ac8600c40ee88573ff177ca75.svg";
export { ForwardRef as ReactComponent };